const fallbackApiUrl = 'https://localhost:8080';

export const env = {
  apiUrl: import.meta.env.VITE_API_URL ?? fallbackApiUrl,
  wsUrl: import.meta.env.VITE_WS_URL ?? fallbackApiUrl.replace(/^http/, 'ws'),
  rateLimitBypassToken: import.meta.env.VITE_RATE_LIMIT_BYPASS_TOKEN ?? null,
};

export type Env = typeof env;
